module.exports = {
  __depends__: [
    require(151),
    require(227),
    require(162),
    require(242)
  ],
  globalConnect: [ 'type', require(165) ]
};
